import React from "react";
import forwardArrow from "../../../assets/icons/forward-arrow.svg";

const RegisterYourInterest = () => {
  return (
    <div className="flex flex-col gap-4 justify-center items-center">
      <h1 className="text-[54px] font-bold">Register Your Interest</h1>
      <p className="font-normal text-center">
        Meet consumer demand for personalisation faster. <br />
        Register your interest for Stride today.
      </p>
      <div className="flex gap-2 items-center">
        <button className="bg-[#1138A5] text-white px-10 py-3 text-xl font-medium rounded-2xl">
          Register Interest
        </button>
        <button className="flex">
          Contact Us
          <img src={forwardArrow} alt="forwardArrow" className="h-5 w-5" />
        </button>
      </div>
    </div>
  );
};

export default RegisterYourInterest;
